export enum EventType {
  SearchBar = "search_bar",
  SearchClick = "search_click",
  SearchResults = "search_results",
  NavigationClick = "navigation_click",
  ShareClick = "share_click",
  OutboundClick = "outbound_click",
  ToggleViewClick = "toggle_view_click",
  OpenDrawer = "open_drawer",
  CloseDrawer = "close_drawer",
  SavedResources = "saved_resources_action",
  RelatedActivities = "related_activities_action",
  ProjectSkills = "project_action",
  ProjectEdit = "project_edit_action",
  Filter = "filter",
  Authentication = "authentication",
  OpenModal = "open_modal",
  CloseModal = "close_modal",
}

export const handleEvent = (
  eventType: EventType,
  eventProperties?: { [key: string]: any },
) => {
  if (!eventType) {
    return;
  }
  try {
    if (window.mixpanel) {
      window.mixpanel.register_once({
        event_source: "xq-competency-navigator",
      });
      window.mixpanel.track(eventType, eventProperties);
    }
  } catch (e) {
    console.error(e);
  }
};

export const handlePageView = (eventProperties?: { [key: string]: any }) => {
  try {
    if (window.mixpanel) {
      window.mixpanel.register_once({
        event_source: "xq-competency-navigator",
      });
      window.mixpanel.track_pageview(eventProperties);
    }
  } catch (e) {
    console.error(e);
  }
};
